import { Box, Typography } from '@mui/material'
import { IconWarning } from 'assets/icons'

type Props = {
  title: string
}

export const IntegrationModalHeader = ({ title }: Props) => {
  return (
    <Box display="flex" alignItems="center">
      <IconWarning sx={{ color: 'warning.main', mr: 1, fontSize: '26px' }} />
      <Typography
        variant="caption2"
        sx={{
          width: 400,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}
      >
        {title}
      </Typography>
    </Box>
  )
}
